module.exports = __webpack_public_path__ + "static/media/settings.5befa14b.svg";